import { config } from '@app/config';
import { AuditLiveMention, toTimestamp } from '@mi-front/core';
import { StreamEl } from '@mi-front/ui';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import { desaturate } from 'polished';
import Popup from 'reactjs-popup';
import { MatchMarker } from '../elements';
import { LiveMentionInfo } from './components/LiveMentionInfo';

interface Props {
  readonly liveMention: AuditLiveMention;
}

export function AuditLiveMentionMarker({ liveMention }: Props) {
  return (
    <StreamEl
      key={liveMention.datetime}
      ts={toTimestamp(liveMention.datetime)}
      offsetX={-18}
      zIndex={10}
    >
      <Popup
        open={config.isTest}
        trigger={
          <MatchMarker color={desaturate(0.2, '#5a5fd3')}>
            <KeyboardVoiceIcon fontSize="small" style={{ marginTop: '-6px' }} />
          </MatchMarker>
        }
        position="bottom center"
        on="hover"
        contentStyle={{
          borderRadius: 6,
          minWidth: 200,
          width: 'auto',
        }}
      >
        <LiveMentionInfo liveMention={liveMention} />
      </Popup>
    </StreamEl>
  );
}
